import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MESSAGES_GET_LATEST_MEDIA_MESSAGES_BEGIN,
  MESSAGES_GET_LATEST_MEDIA_MESSAGES_SUCCESS,
  MESSAGES_GET_LATEST_MEDIA_MESSAGES_FAILURE,
  MESSAGES_GET_LATEST_MEDIA_MESSAGES_DISMISS_ERROR,
} from './constants';
import config from '../../../common/config';
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';
import axios from 'axios';

export function getLatestMediaMessages(args = {}) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: MESSAGES_GET_LATEST_MEDIA_MESSAGES_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${config.messagesMediaUrl}/mediamessages/latest?userId=${args.userId}&groupThreadIds=${args.groupIds}`,
        createAxiosConfigWithAuth(getState()),
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: MESSAGES_GET_LATEST_MEDIA_MESSAGES_SUCCESS,
            data: Object.values(res.data),
          });
          resolve(Object.values(res.data));
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: MESSAGES_GET_LATEST_MEDIA_MESSAGES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissGetLatestMediaMessagesError() {
  return {
    type: MESSAGES_GET_LATEST_MEDIA_MESSAGES_DISMISS_ERROR,
  };
}

export function useGetLatestMediaMessages() {
  const dispatch = useDispatch();

  const {
    latestMediaMessages,
    getLatestMediaMessagesPending,
    getLatestMediaMessagesError,
  } = useSelector(
    (state) => ({
      latestMediaMessages: state.messages.latestMediaMessages,
      getLatestMediaMessagesPending:
        state.messages.getLatestMediaMessagesPending,
      getLatestMediaMessagesError: state.messages.getLatestMediaMessagesError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(getLatestMediaMessages(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissGetLatestMediaMessagesError());
  }, [dispatch]);

  return {
    latestMediaMessages,
    getLatestMediaMessages: boundAction,
    getLatestMediaMessagesPending,
    getLatestMediaMessagesError,
    dismissGetLatestMediaMessagesError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MESSAGES_GET_LATEST_MEDIA_MESSAGES_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getLatestMediaMessagesPending: true,
        getLatestMediaMessagesError: null,
      };

    case MESSAGES_GET_LATEST_MEDIA_MESSAGES_SUCCESS:
      // The request is success
      return {
        ...state,
        latestMediaMessages: action.data,
        getLatestMediaMessagesPending: false,
        getLatestMediaMessagesError: null,
      };

    case MESSAGES_GET_LATEST_MEDIA_MESSAGES_FAILURE:
      // The request is failed
      return {
        ...state,
        getLatestMediaMessagesPending: false,
        getLatestMediaMessagesError: action.data.error,
      };

    case MESSAGES_GET_LATEST_MEDIA_MESSAGES_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getLatestMediaMessagesError: null,
      };

    default:
      return state;
  }
}
